import BaseService from './base.service';

class FacilityService extends BaseService {
  async getAllFacilities() {
    return this.get('/facilities');
  }

  async getFacility(id) {
    return this.get(`/facilities/${id}`);
  }

  async createFacility(facilityData) {
    return this.post('/facilities', facilityData);
  }

  async updateFacility(id, facilityData) {
    return this.put(`/facilities/${id}`, facilityData);
  }

  async deleteFacility(id) {
    return this.delete(`/facilities/${id}`);
  }

  async getDepartments(facilityId) {
    return this.get(`/departments/facility/${facilityId}`);
  }

  async getAllDepartments() {
    return this.get('/departments/workspace');
  }

  async createDepartment(departmentData) {
    return this.post('/departments', departmentData);
  }

  async updateDepartment(departmentId, facilityId, departmentData) {
    return this.put(`/departments/${departmentId}/facility/${facilityId}`, departmentData);
  }

  async deleteDepartment(departmentId, facilityId) {
    return this.delete(`/departments/${departmentId}/facility/${facilityId}`);
  }
}

export default FacilityService;
